import MyAllocationContainer from './MyAllocationContainer';
export default MyAllocationContainer;